<template>
    <div class="flex flex-col gap-4">
        <div v-for="(item, idx) in inferences" :key="idx" class="flex gap-4">
            <div class="grow">
                <p class="nadia-chat-bold">{{ item.profile_question_key }}</p>
                <p class="text-valence-grey-750 nadia-chat">{{ item.value }}</p>
            </div>
            <button
                v-if="!hideForgetButton"
                type="button"
                class="shrink-0 bi bi-trash text-valence-grey-750"
                :aria-label="`Remove ${item.profile_question_key}`"
                :title="`Remove ${item.profile_question_key}`"
                @click="forgetInference(idx)" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { inject } from "vue";

import type { UserProfileData } from "./types/profile";
import { logUserInteraction } from "./utils/logUtils";

const coachingSessionUuid = inject<string>("coachingSessionUuid");

type ChatActionProfileInferencesProp = {
    inferences?: UserProfileData[];
    hideForgetButton?: boolean;
};

const { inferences = [], hideForgetButton = false } = defineProps<ChatActionProfileInferencesProp>();

const emit = defineEmits<{
    "forget-inference": [{ id: number }];
}>();

function forgetInference(inferenceIndex: number) {
    const inference = inferences[inferenceIndex];
    emit("forget-inference", { id: inference.id });
    logUserInteraction("forget_inference", { inference }, coachingSessionUuid);
}
</script>
